import { DeviceTypes } from '../consts';

export const container = ({ isMoving, transitionDuration, isActive, deviceType, isLast }) => ({
    height: '23rem',
    width: '70%',
    transform: isMoving ? 'translateX(20px)' : 'translateX(0px)',
    opacity: isMoving || !isActive ? '0' : '1',
    willChange: 'transform, opacity',
    transition: `cubic-bezier(0.4, 0.0, 0.2, 1) transform ${transitionDuration}s, cubic-bezier(0.4, 0.0, 0.2, 1) opacity ${transitionDuration}s`,
    marginTop: '-14rem',
    position: 'relative',
    right: '-8rem',
    top: '3rem',
    pointerEvents: 'none',

    tablet: {
        width: '100%',
        maxWidth: deviceType === DeviceTypes.PHONE ? '28.6875rem' : '39.3125rem',
        marginTop: deviceType === DeviceTypes.PHONE ? '0.625rem' : '5.4375rem',
        height: '25.3125rem',
        marginRight: '-2rem',
        position: 'absolute',
        top: '-18.75rem',
        right: '-12.5rem',
    },

    tabletLarge: {
        marginRight: 0,
        right: 0,
        top: 'unset',
        height: isLast ? '16.3125rem' : '33.3125rem',
    },
});

export const image = () => ({
    maxHeight: '100%',
});
